import cloneDeepWith from 'lodash.clonedeepwith'
import { AllConfigsType } from './items/types'
import { EnvVariables } from './types'

const removePublicationAfterApply = (
  configObject: AllConfigsType[keyof AllConfigsType]
) => {
  for (var property in configObject) {
    if (Object.prototype.hasOwnProperty.call(configObject, property)) {
      if (
        typeof (configObject as any)[property] === 'object' &&
        !property.endsWith('___romandie') &&
        typeof (configObject as any)[`${property}___romandie`] === 'undefined'
      ) {
        removePublicationAfterApply((configObject as any)[property])
      } else {
        if (typeof property === 'string' && property.endsWith('___romandie')) {
          delete (configObject as any)[property]
        }
      }
    }
  }
}

const publicationAdjustedConfig = (
  publication: EnvVariables['publication'],
  configObject: AllConfigsType[keyof AllConfigsType]
) => {
  const newConfigObject = cloneDeepWith(
    configObject,
    (_value, indexOrkey, object) => {
      if (publication === 'romandie') {
        if (
          typeof indexOrkey === 'string' &&
          !indexOrkey.endsWith('___romandie')
        ) {
          if (
            typeof (object as any)?.[`${indexOrkey}___romandie`] !== 'undefined'
          ) {
            return (object as any)[`${indexOrkey}___romandie`]
          }
        }
      }
    }
  )
  removePublicationAfterApply(newConfigObject)
  return newConfigObject
}

export { publicationAdjustedConfig }
